import { SelectOption } from "../../../types/select";

export const mapRecordToSelectOptions = (record: Record<string, string>): SelectOption[] => {
  return Object.entries(record).map(([value, label]) => ({ value, label }));
};
